import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import './policy.scss';
import { fetchPolicyContent } from 'services/termsService';
import NotFound from 'components/notFound/NotFound';

const VALID_SLUGS = ['terms-and-condition', 'privacy-policy'];

const PolicyPage: React.FC = () => {
  const { lang, slug } = useParams();
  const [pageData, setPageData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);


  useEffect(() => {
    const fetchPageContent = async () => {
      if (!slug || !lang) return;

      if (!VALID_SLUGS.includes(slug)) {
              setNotFound(true);
              setLoading(false);
              return;
            }

      try {
        setLoading(true);
        const result = await fetchPolicyContent(slug, lang);
        if (result && result.data) {
          setPageData(result.data);
        } else {
          setNotFound(true);
        }
      } catch (error) {
        console.error("Fetch Error:", error);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };
    fetchPageContent();
  }, [slug, lang]);

  const cleanContent = useMemo(() => {
    const rawHtml = lang === 'zh' ? pageData?.content?.zh : pageData?.content?.en;

    if (!rawHtml) return '';

    const processedHtml = rawHtml
      .replace(/<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '');

    return DOMPurify.sanitize(processedHtml, {
      ALLOWED_TAGS: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'br', 'strong',
        'em', 'u', 'a', 'ul', 'ol', 'li', 'blockquote', 'code',
        'pre', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'img',
        'div', 'span',
      ],
      ALLOWED_ATTR: [
        'href', 'target', 'rel', 'class', 'id', 'src', 'alt', 'width', 'height',
      ],
      KEEP_CONTENT: true,
    });
  }, [pageData, lang]);

  if (loading) return <div>Loading...</div>;
  if (notFound) return <NotFound />;
  if (!pageData) return null;

  return (
    <div className="legal-page-wrapper">
      <div className="legal-card">
        <h1>
          {lang === 'zh' ? pageData.title?.zh : pageData.title?.en}
        </h1>

        <div className="legal-content">
          <div
            className="terms-html-content"
            dangerouslySetInnerHTML={{ __html: cleanContent }}
          />
        </div>
      </div>
    </div>
  );
};

export default PolicyPage;